import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		grid-template-columns: repeat(4, 1fr);
	}
`;

const Overlay = styled.span`
	position: absolute;
	inset: 0;
	display: none;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.5);
	color: white;
	text-transform: uppercase;
	font-size: 1.25rem;
`;

const Tile = styled.a`
	position: relative;
	&:hover ${Overlay} {
		display: flex;
	}
`;

export default function GalleryBlockDelta({ photos }: { photos: MicrositeResponsiveImage[] }) {
	if (photos.length === 0) return null;

	return (
		<Section id="gallery">
			<Grid>
				{photos.map((photo, index) => (
					<Tile key={index} href="#gallery" data-index={index}>
						<MicrositeResponsiveImg image={photo} priority={LoadPriority.FIRST_PAINT} />
						<Overlay>View Gallery</Overlay>
					</Tile>
				))}
			</Grid>
		</Section>
	);
}
